import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';

interface UserAnomaly {
  division: string;
  section: string;
  plant: string;
  tagNumber: string;
  anomaly: string;
}
@Component({
    selector: 'app-admin-reports-anamoly',
    imports: [
        CommonModule,
        TableModule
    ],
    templateUrl: './admin-reports-anamoly.component.html',
    styleUrl: './admin-reports-anamoly.component.scss'
})
export class AdminReportsAnamolyComponent {
users: UserAnomaly[] = [];
  
  constructor(private adminService: AdminService) {}
  
  ngOnInit() {
    // Call the admin service to get IPEG report data
    this.adminService.getReportsAnamoly().subscribe({
      next: (response) => {
        if (Array.isArray(response)) {
          // Map API response to component data model
          this.users = response.map(item => ({
            division: item.division || '',
            section: item.section|| '',
            plant: item.plant|| '',
            tagNumber: item.tagNumber|| '',
            anomaly: item.anomaly|| ''
          }));
        } else {
          // Handle empty or non-array response
          console.error('Invalid response format - expected array:', response);
          this.users = [];
        }
      },
      error: (error) => {
        console.error('Error fetching IPEG report data:', error);
        this.users = [];
      }
    });
  }
}
